import { FormEvent, useEffect, useState } from "react";
import { userOptionKeys, userOptions } from "./constants";
import {
  CustomInput,
  CustomModal,
  Modal,
  Button,
  PasswordInput,
  CustomInputWithErrorMessage,
  PhoneInputField,
  PhoneInputFieldWithValidation,
} from "components/ui";
import { userDetailState } from "store/selectors";
import { useAppSelector } from "store/hooks";
import {
  emailErrorMessage,
  isNumeric,
  isPhoneNumberValid,
  isValidEmail,
} from "utils/helpers";
import styles from "./styles.module.css";

const { username, email, address, firstName, lastName, phoneNumber, password } =
  userOptionKeys;

type OptionsObjectTypes = {
  [key: string]: string | boolean;
  phone_number?: string;
};

export function UserModal({ showModal = true, onClose, onSubmit }: any) {
  const { userDetail } = useAppSelector(userDetailState);
  const [isEmailValid, setIsEmailValid] = useState<boolean>(false);
  const [addFormData, setAddFormData] =
    useState<OptionsObjectTypes>(userOptions);
  const [isValidPhone, setIsValidPhone] = useState<boolean>(false);

  useEffect(() => {
    setAddFormData(userDetail);
    setIsEmailValid(isValidEmail(userDetail?.email));

    userDetail?.phone_number &&
      setIsValidPhone(isPhoneNumberValid(userDetail?.phone_number));
  }, []);

  function formDataHandler(key: string) {
    if (key === phoneNumber) {
      return (value: string, { isValid }: { isValid: boolean }) => {
        setAddFormData({
          ...addFormData,
          [key]: value,
        });
        setIsValidPhone(isValid);
      };
    }

    return (value: any) => {
      if (key === email) {
        setIsEmailValid(isValidEmail(value));
      }

      setAddFormData({
        ...addFormData,
        [key]: value,
      });
    };
  }

  function submitHandler(event: FormEvent) {
    event.preventDefault();
    onSubmit(addFormData);
    setAddFormData(userOptions);
    onClose();
  }

  const disabledCondition: boolean = !(
    addFormData?.username &&
    addFormData?.email &&
    isEmailValid &&
    addFormData?.phone_number &&
    isValidPhone
  );

  const title = "Update Profile";

  return (
    <CustomModal isOpen={showModal} onClose={onClose}>
      <form onSubmit={submitHandler}>
        <Modal.Header title={title} />
        <Modal.Body classes={styles.modalBody}>
          <InputWrapper label="Username" required>
            <CustomInput
              type="text"
              placeholder="Username.."
              onChange={formDataHandler(username)}
              value={addFormData?.username}
              disabled
            />
          </InputWrapper>

          <InputWrapper label="Email" required>
            <CustomInputWithErrorMessage
              type="email"
              placeholder="Email..."
              onChange={formDataHandler(email)}
              value={addFormData?.email}
              errorMessage={emailErrorMessage({
                condition: isEmailValid,
                value: addFormData?.email,
              })}
            />
          </InputWrapper>

          <InputWrapper label="Address">
            <CustomInput
              type="text"
              placeholder="Address..."
              onChange={formDataHandler(address)}
              value={addFormData?.address}
            />
          </InputWrapper>

          {/* <InputWrapper label="Phone Number" required>
            <CustomInput
              type="text"
              placeholder="+92XXXXXXXXXX"
              onChange={formDataHandler(phoneNumber)}
              value={addFormData?.phone_number}
              maxLength="13"
            />
          </InputWrapper> */}

          <InputWrapper label="Phone Number" required>
            {/* <PhoneInputField
              placeholder="+92XXXXXXXXXX"
              onChange={formDataHandler(phoneNumber)}
              value={addFormData?.phone_number}
            /> */}

            <PhoneInputFieldWithValidation
              onBlur={() => ""}
              onChange={formDataHandler(phoneNumber)}
              value={addFormData?.phone_number}
              error={!isValidPhone}
            />
          </InputWrapper>

          <InputWrapper label="First Name">
            <CustomInput
              type="text"
              placeholder="First Name..."
              onChange={formDataHandler(firstName)}
              value={addFormData?.first_name}
            />
          </InputWrapper>

          <InputWrapper label="Last Name">
            <CustomInput
              type="text"
              placeholder="Last Name..."
              onChange={formDataHandler(lastName)}
              value={addFormData?.last_name}
            />
          </InputWrapper>

          <InputWrapper label="Password">
            <PasswordInput
              onChange={formDataHandler(password)}
              value={addFormData?.password || ""}
              autoComplete="user-password"
            />
          </InputWrapper>
        </Modal.Body>

        <Modal.Footer classes="flex justify-center">
          <Button
            type="submit"
            variant="green"
            className="w-full max-w-96 !py-3"
            disabled={disabledCondition}
          >
            Update
          </Button>
        </Modal.Footer>
      </form>
    </CustomModal>
  );
}

function InputWrapper({ children, label, required = false }: any) {
  return (
    <div className={styles.inputWrapper}>
      <label className={`${required ? styles.required : ""}`}>{label}</label>
      {children}
    </div>
  );
}
